import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AuthenticationSlice = {
  isAuthenticated: boolean;
  isAuthenticationLoading: boolean;
};

const initialState = {
  isAuthenticated: false,
  isAuthenticationLoading: true,
} as AuthenticationSlice;

const authenticationSlice = createSlice({
  name: 'authenticationSlice',
  initialState,
  reducers: {
    setAuthenticationStatus(state, { payload: isAuthenticated }: PayloadAction<boolean>) {
      state.isAuthenticated = isAuthenticated;
    },

    setAuthenticationLoadingStatus(state, { payload: isAuthenticationLoading }: PayloadAction<boolean>) {
      state.isAuthenticationLoading = isAuthenticationLoading;
    },
  },
});

export const { setAuthenticationStatus, setAuthenticationLoadingStatus } = authenticationSlice.actions;
export default authenticationSlice;
